import html from "./WebVisualization.html"
import "./WebVisualization.css"
import { connectExternalAccount, promptForAccountRemoval } from '../../../helpers/providerAccounts';

var module = angular.module("ResearchKitApplicationModule");

module.directive("webVisualizationDashboardComponent",
	["$timeout", "$window", "$rootScope", "ceUrl", "$http", "delegatedOAuthClient", "$translate", function ($timeout, $window, $rootScope, ceUrl, $http, delegatedOAuthClient, $translate) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"model": "=",
				"restrictToProject": "="
			},
			link: function (scope, element) {
				scope.loading = true;
				scope.currentHeight = 44;

				var contentWindow = element.find("iframe")[0].contentWindow;

				if (!$window.webVisualizationMessageHandler) {
					$window.webVisualizationMessageHandler = function (event) {
						if (event.origin !== $window.location.origin) return;

						scope.$apply(function () {
							if (!event.data) return;

							$rootScope.$broadcast("WebVisualizationMessageReceived", event);
						});
					};
				}
				// duplicate event listener registrations will be discarded as long as we aren't registering an anonymous function
				$window.addEventListener("message", $window.webVisualizationMessageHandler);

				scope.$on("connectExternalAccountDidFinish", function (event, parameters) {
					contentWindow.postMessage({ action: event.name, messageID: parameters.messageID, success: parameters.success, errorMessage: parameters.errorMessage }, "/");
				});

				scope.$on("WebVisualizationMessageReceived", function (event, message) {
					if (message.source !== contentWindow) return;

					if (message.data.name === "SetHeight") {
						scope.loading = false;
						scope.currentHeight = message.data.message;
					} else if (message.data.name === "GetAccessToken" || message.data.name === "GetDelegatedAccessToken") {
						$http({
							method: 'POST',
							url: ceUrl.make('identityserver/connect/token'),
							data: $.param({
								grant_type: "delegated_participant",
								participant_id: scope.model.PatientID,
								client_id: delegatedOAuthClient.ClientID,
								client_secret: delegatedOAuthClient.ClientSecret,
								scope: "api user/*.read"
							}),
							headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
						}).then(function (response) {
							contentWindow.postMessage({ action: message.data.name, success: true, data: response.data, messageID: message.data.messageID, baseUrl: $window.location.origin + ceUrl.getRoot() }, '/');
						}).catch(function () {
							contentWindow.postMessage({ action: message.data.name, success: false, message: "Unable to retrieve access token", messageID: message.data.messageID }, '/');
						});
					} else if (message.data.name === "DeleteProviderAccount") {
						promptForAccountRemoval(message.data.message, contentWindow, '/', $translate.instant('delete-account-confirm-message', null, null, 'Do you really want to delete this account?'));
					} else if (message.data.name === "ConnectExternalAccount" && message.data.message.externalAccountProviderID) {
						connectExternalAccount(
							message.data.message.externalAccountProviderID,
							message.data.message.messageID,
							message.data.message.openNewWindow,
							message.data.message.width,
							message.data.message.height);
					} else if (message.data.name === "OpenApplication") {
						scope.$emit("performAction", { type: message.data.name, event: message.data });
					} else {
						var action = { type: message.data.name, parameters: message.data.message, patientID: scope.model.PatientID };
						scope.$emit("performAction", action);
					}
				});

				scope.getFrameUrl = function () {
					var url = "webvisualization/webvisualization?visualizationKey=" + encodeURIComponent(scope.model.VisualizationKey) + "&patientID=" + encodeURIComponent(scope.model.PatientID);
					if (scope.restrictToProject) {
						url = url + "&restrictToProject=true";
					}
					return ceUrl.make(url);
				}
			}
		}
	}]
);